import { all, call, delay, fork, put, takeLeading } from 'redux-saga/effects';
import ApiConstants from 'src/common/helpers/ApiConstants';
import * as requests from 'src/common/helpers/HTTPRequest';
import {
  resetPasswordActions,
  resetPasswordCleanState,
  resetPasswordError,
  resetPasswordSuccess,
  setNewPasswordCleanState,
  setNewPasswordError,
  setNewPasswordSuccess,
} from './actions';

function* resetPassword({ payload }) {
  try {
    const requestBody = { ...payload };
    const url = `${ApiConstants.BASE_URL}${ApiConstants.RESET_PASSWORD}`;
    const apiRes = yield call(requests.postRequest, url, requestBody, false);
    if (apiRes) {
      yield put(resetPasswordSuccess(apiRes?.message || ''));
    } else {
      yield put(resetPasswordError({ message: 'Oops! something went wrong!' }));
    }
  } catch (error) {
    console.log(error);
    yield put(resetPasswordError({ message: error?.message || '' }));
  } finally {
    yield delay(2500);
    yield put(resetPasswordCleanState());
  }
}

function* setNewPassword({ payload }) {
  try {
    const requestBody = { ...payload };
    const url = `${ApiConstants.BASE_URL}${ApiConstants.SET_NEW_PASSWORD}`;
    const apiRes = yield call(requests.postRequest, url, requestBody, false);
    if (apiRes) {
      yield put(setNewPasswordSuccess(apiRes?.message || ''));
    } else {
      yield put(
        setNewPasswordError({ message: 'Oops! something went wrong!' })
      );
    }
  } catch (error) {
    console.log(error);
    yield put(setNewPasswordError({ message: error?.message || '' }));
  } finally {
    yield delay(5000);
    yield put(setNewPasswordCleanState());
  }
}

export function* watchForgotPassword() {
  yield takeLeading(resetPasswordActions.RESET_PASSWORD, resetPassword);
  yield takeLeading(resetPasswordActions.SET_NEW_PASSWORD, setNewPassword);
}

export default function* rootSaga() {
  yield all([fork(watchForgotPassword)]);
}
